var _rect, _path, _path2, _mask, _path3, _path4, _mask2, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "var(--primary-color-text)",
    fillOpacity: 0.13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 15V6C7 5.73478 7.10536 5.48043 7.29289 5.29289C7.48043 5.10536 7.73478 5 8 5H12C12.2652 5 12.5196 5.10536 12.7071 5.29289C12.8946 5.48043 13 5.73478 13 6V15H7Z",
    fill: "var(--primary-color-text)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7H11M9 9H11M9 11H11M9 13H11",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_7598_17210",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 10H6C5.44772 10 5 10.4477 5 11V15H7V10Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10H6C5.44772 10 5 10.4477 5 11V15H7V10Z",
    fill: "var(--primary-color-text)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10H5H7ZM5 15H7H5ZM7.1 15V10H6.9V15H7.1ZM5 10V15V10Z",
    fill: "white",
    mask: "url(#path-4-inside-1_7598_17210)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_7598_17210",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 10H14C14.5523 10 15 10.4477 15 11V15H13V10Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10H14C14.5523 10 15 10.4477 15 11V15H13V10Z",
    fill: "var(--primary-color-text)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10H15H13ZM15 15H13H15ZM12.9 15V10H13.1V15H12.9ZM15 10V15V10Z",
    fill: "white",
    mask: "url(#path-6-inside-2_7598_17210)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanIcon);
export default __webpack_public_path__ + "static/media/companIcon.72c785f105f3e6b4b4433ac7a5536552.svg";
export { ForwardRef as ReactComponent };